import { createContext } from 'react';

export interface CarouselContextType {
  nbElement: number;
  isDark?: boolean;
  isLoop?: boolean;
  isAutoplay?: boolean | number;
  paginationPosition?: 'top' | 'bottom';
  elementSelected: number;
  setElementSelected?: any;
  classNamePagination?: string;
  onClickPrev?: () => void;
  onClickNext?: () => void;
  onClickDot?: (number) => void;
  screensize?: string;
}

export const CarouselContext = createContext<CarouselContextType>({
  nbElement: 0,
  elementSelected: 0,
});
